import { render, staticRenderFns } from "./CreateContractFromCustomerComponent.vue?vue&type=template&id=04041c42&scoped=true"
import script from "./CreateContractFromCustomerComponent.vue?vue&type=script&lang=js"
export * from "./CreateContractFromCustomerComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateContractFromCustomerComponent.vue?vue&type=style&index=0&id=04041c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04041c42",
  null
  
)

export default component.exports